module.exports = __webpack_public_path__ + "img/tc-7.e6f16a70.png";